import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { InventoryFormDialogComponent } from '../inventory-form-dialog/inventory-form-dialog.component';
import { IUserInventoryList } from 'src/app/state-management/states/aumye-dashboard.state';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-my-list-inventory',
  templateUrl: './my-list-inventory.component.html',
  styleUrls: ['./my-list-inventory.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class MyListInventoryComponent {
  inventoryFilter = new FormControl();
  filteredInventory: any[];
  screenSize: ScreenType;
  ScreenType = ScreenType;
  selectedAttachments: any;
  expandedElement: IUserInventoryList | null;
  isShowInventoryDetails = false;
  expandedDetail: string = null;
  displayedColumns = [
    'index',
    'inventoryId',
    'listName',
    'deliveryDate',
    'totalitems',
    'detail',
  ];
  newDisplayedColumns = ['index', 'itemName', 'quantity', 'units'];
  columnsToDisplayWithExpand = [...this.displayedColumns, 'expand'];
  @Output() onSaveUserList = new EventEmitter();
  @Output() inventoryFormData = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService
  ) {
    this.filteredInventory = data.userInventory;
    console.log(this.filteredInventory);
    this.inventoryFilter.valueChanges.subscribe((value) => {
      this.filteredInventory = this.filterInventory(value);
    });
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }

  filterInventory(value: string) {
    const filterValue = value.toLowerCase();
    return this.data
      ? this.data.userInventory.filter((inventory: any) =>
          `${inventory.listName}`.toLowerCase().includes(filterValue)
        )
      : [];
  }
  getExpandState(element: IUserInventoryList): string {
    return element === this.expandedElement ? 'expanded' : 'collapsed';
  }
  toggleExpandedElement(element: IUserInventoryList, event: Event): void {
    this.expandedElement = this.expandedElement === element ? null : element;
    event.stopPropagation();
  }
  onClickDetails(val: any) {
    if (this.expandedElement) {
      if (
        this.expandedElement.inventoryId === val.inventoryId &&
        this.isShowInventoryDetails
      ) {
        this.isShowInventoryDetails = false;
        this.expandedElement = null;
      } else {
        this.isShowInventoryDetails = true;
      }
    } else {
      this.isShowInventoryDetails = true;
    }
    this.expandedElement = val;

    if (this.isShowInventoryDetails) this.expandedDetail = val.inventoryId;
    else this.expandedDetail = null;
    if (this.screenSize === 3) {
      setTimeout(() => {
        const targetElement = document.querySelector('.mobile-detail-view');
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 250);
    }
  }
  inventorySelect(val: MatAutocompleteSelectedEvent) {}
  onAttachmentSelected(event: any): void {
    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      this.selectedAttachments = fileInput.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const contents = e.target.result as string;
      };
    }
  }
  onCreateInventoryForm() {
    const data = {
      userEvents: this.data.orgEvents,
      vendorRequests: this.data.orgVendorRequests,
      users: this.data.users,
      screen: this.screenSize,
    };
    const dialogRef = this.dialog.open(InventoryFormDialogComponent, {
      disableClose: false,
      data: data,
    });
    dialogRef.componentInstance.onSaveInventory.subscribe((data: any) => {
      data['existingInventory'] = this.data.userInventory;
      this.onSaveUserList.emit(data);
      this.inventoryFormData.emit(dialogRef);
    });
  }
}
